import { createFileRoute } from "@tanstack/react-router";
import { AuthLayout } from "#app/components/auth/auth-layout";
import { AcceptInviteForm } from "#app/components/auth/accept-invite-form";

function AcceptInviteScreen() {
  return (
    <AuthLayout
      heading="Accept Invitation"
      subheading="Set your name and password to finish setting up your account."
      footerText="Already have an account?"
      footerLinkText="Sign in"
      footerLinkHref="/login"
    >
      <AcceptInviteForm />
    </AuthLayout>
  );
}

export const Route = createFileRoute("/(auth)/accept-invite")({
  component: AcceptInviteScreen,
});
